import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
	user: null,
	services: null,
	opnhrs: null,
	token: Cookies.get('token')
}

// getters
export const getters = {
	user: state => state.user,
	services: state => state.services,
	servicesId: state => state.services.map(x => x.id),
	opnhrs: state => state.opnhrs,
	token: state => state.token,
	check: state => state.user !== null
}

// mutations
export const mutations = {
	[types.SAVE_TOKEN](state, { token, remember }) {
		state.token = token
		Cookies.set('token', token, { expires: remember ? 365 : null })
	},

	[types.FETCH_USER_SUCCESS](state, user) {
		state.user = user
	},

	[types.FETCH_SERVICES](state, services) {
		state.services = services
	},

	[types.FETCH_OPNHRS](state, opnhrs) {
		state.opnhrs = opnhrs
	},

	[types.FETCH_USER_FAILURE](state) {
		state.token = null
		Cookies.remove('token')
	},

	[types.LOGOUT](state) {
		state.user = null
		state.services = null
		state.token = null

		Cookies.remove('token')
	},

	[types.UPDATE_USER](state, { user }) {
		state.user = user
	}
}

// actions
export const actions = {
	saveToken({ commit }, payload) {
		commit(types.SAVE_TOKEN, payload)
	},

	async fetchUser({ commit, state, dispatch }) {
		try {
			const { data } = await axios.get('/barber')
			commit(types.FETCH_USER_SUCCESS, data)

			if (state.services === null || state.opnhrs === null) {
				await dispatch('fetchServices')
				await dispatch('fetchOpnhrs')
			}

			// await this.$store.dispatch('auth/fetchServices')
		} catch (e) {
			commit(types.FETCH_USER_FAILURE)
		}
	},

	async fetchServices({ commit }) {
		try {
			const { data } = await axios.get('/barber/services')
			commit(types.FETCH_SERVICES, data)
		} catch (e) {
			commit(types.FETCH_USER_FAILURE)
		}
	},

	async fetchOpnhrs({ commit }) {
		try {
			const { data } = await axios.get('/barber/opnhrs')
			commit(types.FETCH_OPNHRS, data)
		} catch (e) {
			commit(types.FETCH_USER_FAILURE)
		}
	},

	updateUser({ commit }, payload) {
		commit(types.UPDATE_USER, payload)
	},

	async logout({ commit }) {
		try {
			await axios.post('/logout')
		} catch (e) {
			null
		}

		commit(types.LOGOUT)
	},

	async fetchOauthUrl(ctx, { provider }) {
		const { data } = await axios.post(`/oauth/${provider}`)

		return data.url
	}
}
